<template>
  <div
    class="position-relative d-flex"
    v-closable="{
      exclude: ['ref1', 'ref2'],
      handler: 'closeDpd',
    }"
  >
    <label class="qb-gotopage-text mr-2">Items per page</label>
    <div
      class="pointer position-relative"
      ref="ref1"
      @click="showDpd = !showDpd"
    >
      <div class="page-chkbx">{{ inputData }}</div>
      <div ref="ref2" class="arr-page">
        <img src="../../assets/dwn_arr_page.svg" />
      </div>
    </div>
    <div v-if="showDpd" class="dpd-page btns-stckd">
      <b-form-group class="btns-stckd">
        <b-form-radio-group
          name="radio-btn-stacked"
          class="w-100"
          :options="pageCounts"
          v-model="inputData"
          @change="$emit('update-value', inputData), (showDpd = false)"
          size="sm"
          buttons
          stacked
        ></b-form-radio-group>
      </b-form-group>
    </div>
  </div>
</template>

<script>
export default {
  name: "input",
  props: {
    pagecount: Number,
    type: String,
    vmodel: {
      validator: function () {
        // Accept any type
        return true;
      },
    },
  },
  data() {
    return {
      inputData: "",
      showDpd: false,
      pageCounts: [
        { text: "10", value: 10 },
        { text: "50", value: 50 },
        { text: "100", value: 100 },
        { text: "125", value: 125 },
        { text: "200", value: 200 },
      ],
    };
  },
  created() {
    if (this.pagecount) {
      this.inputData = this.pagecount;
    }
  },
  methods: {
    restrictAlpha(evt) {
      if (evt.target.nodeName === "INPUT") {
        const charCode = evt.key;

        if ((charCode < "0" || charCode > "9") && charCode !== ".") {
          evt.preventDefault();
        } else {
          return true;
        }
      }
    },
    closeDpd() {
      this.showDpd = false;
    },
  },
};
</script>

<style scoped>
/* Hide number icon */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}
.page-chkbx {
  background: #ffffff;
  border: 1px solid #d0d5dd;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 5px;
  width: 49px;
  height: 23px;
  font-weight: 400;
  font-size: 13px;
  color: #72738e;
  padding-right: 18px;
  padding-left: 5px;
}
.qb-gotopage-text {
  font-family: "Montserrat";
  font-weight: 500;
  font-size: 12px;
  color: #20639b;
}
.topDiv {
  position: absolute;
  right: 180px;
  bottom: 27px;
}
.arr-page {
  position: absolute;
  right: 6px;
  bottom: 1px;
}
.dpd-page {
  position: absolute;
  background: #f9f9f9;
  border: 1px solid rgba(41, 136, 230, 0.22);
  bottom: 26px;
  width: 70px;
  left: 80px;
  border-radius: 5px !important;
  box-shadow: 0px 0px 13px 0px #00000040;
}

.dpd-txt {
  font-family: "Lato";
  font-weight: 500;
  font-size: 13px;
  /* identical to box height, or 185% */
  color: #3a3c40;
}
.selected-count {
  background: #e8eff4;
}
</style>
